export const TICKET_TIERS = [
  {
    id: 'basic',
    name: 'Basic',
    tagline: 'Lowest fare',
    upgrade: 0,
    features: [
      { label: 'Personal item', value: 'Included' },
      { label: 'Carry-on bag', value: 'Fee applies' },
      { label: 'Checked bag', value: 'Add-on' },
      { label: 'Seat selection', value: 'Fee applies' },
      { label: 'Flight changes', value: 'Not allowed' },
      { label: 'Refunds', value: 'Non-refundable' },
      { label: 'Priority boarding', value: '—' },
    ],
  },
  {
    id: 'standard',
    name: 'Standard',
    tagline: 'Most popular',
    upgrade: 35,
    features: [
      { label: 'Personal item', value: 'Included' },
      { label: 'Carry-on bag', value: 'Included' },
      { label: 'Checked bag', value: '1st bag fee' },
      { label: 'Seat selection', value: 'Standard seats free' },
      { label: 'Flight changes', value: 'Fee applies' },
      { label: 'Refunds', value: 'Airline credit' },
      { label: 'Priority boarding', value: '—' },
    ],
  },
  {
    id: 'flexible',
    name: 'Flexible',
    tagline: 'Maximum flexibility',
    upgrade: 65,
    features: [
      { label: 'Personal item', value: 'Included' },
      { label: 'Carry-on bag', value: 'Included' },
      { label: 'Checked bag', value: '1 bag included' },
      { label: 'Seat selection', value: 'Any seat free' },
      { label: 'Flight changes', value: 'Free changes' },
      { label: 'Refunds', value: 'Refundable fare' },
      { label: 'Priority boarding', value: 'Included' },
    ],
  },
];

export const UPSELL_PRICES = {
  webCheckIn: 10.99,
  cancellationProtection: 29.99,
};

export const TAX_RATE = 0.12;

export function parseTravelerCount(travelerLabel = '1 Traveler(s)') {
  const match = String(travelerLabel).match(/(\d+)/);
  return match ? Math.max(1, Number(match[1])) : 1;
}

export function getTierById(tierId) {
  return TICKET_TIERS.find((t) => t.id === tierId) || TICKET_TIERS[0];
}

/**
 * Build checkout line items and totals from base fare + optional flight add-ons.
 */
export function computeBookingPrice({
  baseAmount,
  totalAmount,
  travelerLabel = '1 Traveler(s)',
  serviceLabel = 'Base fare',
  tierId = 'basic',
  webCheckIn = false,
  cancellationProtection = false,
  isFlight = false,
  currency = 'USD',
}) {
  const travelers = isFlight ? parseTravelerCount(travelerLabel) : 1;
  const base = Number(baseAmount) || 0;
  const tier = getTierById(tierId);
  const tierUpgrade = isFlight ? tier.upgrade * travelers : 0;

  const baseLineAmount = isFlight
    ? base * travelers
    : Number(totalAmount) || base;

  const lineItems = [
    {
      key: 'base',
      label: isFlight ? `${serviceLabel} × ${travelers}` : serviceLabel,
      amount: baseLineAmount,
      highlight: false,
    },
  ];

  if (tierUpgrade > 0) {
    lineItems.push({
      key: 'tier',
      label: `${tier.name} fare upgrade × ${travelers}`,
      amount: tierUpgrade,
      highlight: true,
    });
  }

  if (isFlight && webCheckIn) {
    lineItems.push({
      key: 'checkin',
      label: 'Web check-in',
      amount: UPSELL_PRICES.webCheckIn,
      highlight: false,
    });
  }

  if (isFlight && cancellationProtection) {
    lineItems.push({
      key: 'protection',
      label: 'Cancellation protection',
      amount: UPSELL_PRICES.cancellationProtection,
      highlight: false,
    });
  }

  const subtotal = lineItems.reduce((sum, row) => sum + row.amount, 0);
  const taxes = Math.round(subtotal * TAX_RATE * 100) / 100;
  const total = Math.round((subtotal + taxes) * 100) / 100;

  return {
    currency,
    travelers,
    tier,
    tierId: tier.id,
    tierUpgrade,
    lineItems,
    subtotal,
    taxes,
    total,
    selectedTierName: tier.name,
  };
}
